exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".MasterAccounts_actionCell_1K7a {\n  text-align: right;\n}\n\n.MasterAccounts_footer_1cUV {\n  margin-top: 20px;\n  padding-top: 20px;\n\n  display: -webkit-box;\n\n  display: -webkit-flex;\n\n  display: -ms-flexbox;\n\n  display: flex;\n  -webkit-flex-wrap: wrap;\n      -ms-flex-wrap: wrap;\n          flex-wrap: wrap;\n  -webkit-box-pack: justify;\n  -webkit-justify-content: space-between;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n\n  border-top: 1px solid #e6e6e6;\n}\n\n.MasterAccounts_footerButton_3o4q {\n  margin-bottom: 10px;\n}\n\n.MasterAccounts_prohibitMasterAccounts_2aVA {\n  margin: 10px 0;\n}\n\n.MasterAccounts_emptyMessage_fa9Z {\n  text-align: center;\n\n  color: #787878;\n}\n", ""]);

// exports
exports.locals = {
	"actionCell": "MasterAccounts_actionCell_1K7a",
	"footer": "MasterAccounts_footer_1cUV",
	"footerButton": "MasterAccounts_footerButton_3o4q",
	"prohibitMasterAccounts": "MasterAccounts_prohibitMasterAccounts_2aVA",
	"emptyMessage": "MasterAccounts_emptyMessage_fa9Z"
};